export default {
  DAY: {
    LAST_DAY: 'last_day',
    FROM_DAY: 'from_day'
  },
  WEEK: {
    WEEK_TO_DATE: 'week_to_date',
    LAST_WEEK: 'last_week',
    FORM_WEEK: 'form_week'
  },
  MONTH: {
    MONTH_TO_DATE: 'month_to_date',
    LAST_MONTH: 'last_month',
    FORM_MONTH: 'form_month'
  },
  YEAR: {
    YEAR_TO_DATE: 'year_to_date',
    LAST_YEAR: 'last_year',
    FORM_YEAR: 'form_year'
  }
}
